import {
  SearchReceivedInvoicesResponseReceivedInvoicesItemAllOfErrorMessagesItem,
  SearchReceivedInvoicesResponseReceivedInvoicesItemAllOfErrorMessagesItemMessageType,
} from 'ap-openapi';
import { FC, PropsWithChildren, createContext, useContext } from 'react';

const Context = createContext<
  | SearchReceivedInvoicesResponseReceivedInvoicesItemAllOfErrorMessagesItem[]
  | undefined
>(undefined);

type Props = {
  value:
    | SearchReceivedInvoicesResponseReceivedInvoicesItemAllOfErrorMessagesItem[]
    | undefined;
};

export const ErrorMessagesProvider: FC<PropsWithChildren<Props>> = ({
  value,
  children,
}) => {
  return <Context.Provider value={value}>{children}</Context.Provider>;
};

export const useGetErrorMessages = () => {
  const value = useContext(Context);
  const getErrorMessage = (
    messageType: SearchReceivedInvoicesResponseReceivedInvoicesItemAllOfErrorMessagesItemMessageType
  ) => {
    return Array.isArray(value)
      ? value?.find((item) => item.message_type === messageType)
      : undefined;
  };
  return { getErrorMessage };
};

export const useErrorMessages = () => {
  return useContext(Context);
};
